//returns a boolean wheather any addresses are loading to determine if spinner is shown
export default (state) => ({
    loading: !!state?.addressBook?.addresses?.some(({ loading }) => loading)
})
